import axios from 'axios'

export class Promptpai {
  constructor () {
    this.axios = axios
    this.site = process.env.PROMPTPAI_URL
    this.getQueryString = function (obj) {
      var str = []
      for (var p in obj) {
        if (obj[p] !== undefined) {
          if (obj[p] instanceof Array) {
            for (var i = 0; i < obj[p].length; i++) {
              str.push(encodeURIComponent(p) + '[' + i + ']=' + encodeURIComponent(JSON.stringify(obj[p][i])))
            }
          } else {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
          }
        }
      }
      return str.join('&')
    }
  }

  initialApp (username, ldtoken, uuid, ref, callback = false) {
    var self = this
    var data = self.getQueryString({
      username: username,
      ldtoken: ldtoken,
      uuid: uuid,
      ref: ref
    })
    self.axios({
      url: `/ws/promptpai/initial?${data}`,
      method: 'get',
      baseURL: self.site,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  reverseGeocoding (id, lat, lon, locale, callback = false) {
    var self = this
    var url = 'https://api.longdo.com/map/services/address'
    var data = self.getQueryString({
      key: process.env.LONGDO_MAP_API_KEY,
      id: id,
      lat: lat,
      lon: lon,
      locale: locale
    })
    self.axios.post(url, data, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  suggestPlaces (keyword, ref, callback = false) {
    var self = this
    if (keyword.length > 1) {
      var data = self.getQueryString({
        keyword: keyword,
        ref: ref
      })
      self.axios({
        url: `/ws/suggest?${data}`,
        method: 'get',
        baseURL: self.site,
        headers: {
          'Content-type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        if (callback) {
          callback(response.data)
        }
      }).catch(function (error) {
        if (callback) {
          console.log(error)
          callback(error.response.data)
        }
      })
    }
  }

  searchPlaces (keyword, lat = 13.764955, lon = 100.538317, limit = 100, page, ref, callback = false) {
    // var self = this
    // var list = [...Array(page)].map((v, i) => ++i)
    // var axiosList = list.map((i) => {
    //   var data = self.getQueryString({
    //     keyword: keyword,
    //     lat: lat,
    //     lon: lon,
    //     limit: limit,
    //     offset: limit * (i - 1),
    //     ref: ref
    //   })
    //   return self.axios({
    //     url: `/ws/search?${data}`,
    //     method: 'get',
    //     baseURL: self.site,
    //     headers: {
    //       'Content-type': 'application/x-www-form-urlencoded'
    //     }
    //   })
    // })
    // self.axios.all(axiosList).then(axios.spread((...response) => {
    //   var data = []
    //   for (var i = 0; i < response.length; i++) {
    //     data = data.concat(response[i].data.data)
    //   }
    //   response[response.length - 1].data.data = data
    //   if (callback) {
    //     callback(response[response.length - 1].data)
    //   }
    // })).catch((...error) => {
    //   if (callback) {
    //     console.log(error[0])
    //     callback(error[0].response.data)
    //   }
    // })

    var self = this
    var data = self.getQueryString({
      keyword: keyword,
      lat: lat,
      lon: lon,
      limit: limit,
      offset: limit * (page - 1),
      ref: ref
    })
    self.axios({
      url: `/ws/search?${data}`,
      method: 'get',
      baseURL: self.site,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  getNearbyPlaces (lat = 13.764955, lon = 100.538317, offset, ref, callback = false) {
    var self = this
    var data = self.getQueryString({
      offset: offset,
      ref: ref
    })
    self.axios({
      url: `/ws/nearby/${lat}/${lon}?${data}`,
      method: 'get',
      baseURL: self.site,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  getPromptpaiDescription (promptpaiId, username, ldtoken, uuid, notiId, ref, callback = false) {
    var self = this
    var data = self.getQueryString({
      key: process.env.LONGDO_MAP_API_KEY,
      username: username,
      ldtoken: ldtoken,
      uuid: uuid,
      noti_id: notiId,
      ref: ref
    })
    self.axios({
      url: `/ws/promptpai/${promptpaiId}?${data}`,
      method: 'get',
      baseURL: self.site,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  forgotPassword (locale, username, ref, callback = false) {
    var self = this
    var url = `${this.site}/ws/forgotpassword`
    var data = self.getQueryString({
      username: username,
      ref: ref,
      locale: locale
    })
    self.axios.post(url, data, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  login (locale, username, pass, spass, ldtoken, socialType, socialUid, socialToken, socialEmail, uuid, ref, callback = false) {
    var self = this
    var url = `${this.site}/ws/login`
    var data = self.getQueryString({
      locale: locale,
      username: username,
      pass: pass,
      spass: spass,
      ldtoken: ldtoken,
      socialtoken: socialType && socialUid && socialToken ? `${socialType}:${socialUid}:${socialToken}` : undefined,
      email: socialEmail,
      uuid: uuid,
      ref: ref
    })
    self.axios.post(url, data, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  registerAccount (locale, email, pass, uuid, ref, callback = false) {
    var self = this
    var url = `${self.site}/ws/register`
    var data = self.getQueryString({
      locale: locale,
      email: email,
      pass: pass,
      client: 'web',
      uuid: uuid,
      ref: ref
    })
    self.axios.post(url, data, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  registerFcmToken (username, ldtoken, uuid, fcmtoken, device, ref, callback = false) {
    var self = this
    var url = `${self.site}/ws/registerfcm`
    var data = self.getQueryString({
      username: username,
      ldtoken: ldtoken,
      uuid: uuid,
      fcmtoken: fcmtoken,
      device: device,
      ref: ref,
      useragent: undefined
    })
    self.axios.post(url, data, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  getUuid (ref, callback = false) {
    var self = this
    var data = self.getQueryString({
      ref: ref
    })
    self.axios({
      url: `/ws/promptpai/uuid?${data}`,
      method: 'get',
      baseURL: self.site,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  getUserInformation (uid, ref, callback = false) {
    var self = this
    var data = self.getQueryString({
      ref: ref
    })
    self.axios({
      url: `/ws/user/${uid}?${data}`,
      method: 'get',
      baseURL: self.site,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  getSearchHistory (username, ldtoken, uuid, ref, callback = false) {
    var self = this
    var data = self.getQueryString({
      username: username,
      ldtoken: ldtoken,
      uuid: uuid,
      ref: ref
    })
    self.axios({
      url: `/ws/promptpai/history?${data}`,
      method: 'get',
      baseURL: self.site,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  getFavoritePlaces (username, ldtoken, uuid, limit, offset, ref, callback = false) {
    var self = this
    var data = self.getQueryString({
      username: username,
      ldtoken: ldtoken,
      uuid: uuid,
      limit: limit,
      offset: offset,
      ref: ref
    })
    self.axios({
      url: `/ws/promptpai/favorites?${data}`,
      method: 'get',
      baseURL: self.site,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  setFavoritePlaces (promptpaiId, state, username, ldtoken, uuid, ref, callback = false) {
    var self = this
    var url = `${self.site}/ws/promptpai/favorites/${promptpaiId}`
    var data = self.getQueryString({
      state: state,
      username: username,
      ldtoken: ldtoken,
      uuid: uuid,
      ref: ref
    })
    self.axios.post(url, data, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  sendLocation (uid, promptpaiId, username, ldtoken, uuid, ref, callback = false) {
    var self = this
    var url = `${this.site}/ws/promptpai/sendlocation/${uid}/${promptpaiId}`
    var data = self.getQueryString({
      username: username,
      ldtoken: ldtoken,
      uuid: uuid,
      ref: ref
    })
    self.axios.post(url, data, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  getReceivedPlaces (username, ldtoken, uuid, limit, ref, callback = false) {
    var self = this
    var data = self.getQueryString({
      username: username,
      ldtoken: ldtoken,
      uuid: uuid,
      limit: limit,
      ref: ref
    })
    self.axios({
      url: `/ws/promptpai/received?${data}`,
      method: 'get',
      baseURL: self.site,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  getRecentPlaces (username, ldtoken, uuid, limit, filter, offset, ref, callback = false) {
    var self = this
    var data = self.getQueryString({
      username: username,
      ldtoken: ldtoken,
      uuid: uuid,
      limit: limit,
      filter: filter,
      offset: offset,
      ref: ref
    })
    self.axios({
      url: `/ws/promptpai/recents?${data}`,
      method: 'get',
      baseURL: self.site,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  getPlaceCategories (username, ldtoken, locale, callback = false) {
    var self = this
    var data = self.getQueryString({
      username: username,
      ldtoken: ldtoken,
      locale: locale
    })
    self.axios({
      url: `/ws/promptpai/categories?${data}`,
      method: 'get',
      baseURL: self.site,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  createNewPromptpai (data, ref, callback = false) {
    var self = this
    var url = `${this.site}/ws/promptpai`
    var formData = new FormData()
    var i
    if (data.uuid) {
      formData.append('uuid', data.uuid)
    } else {
      formData.append('username', data.username)
      formData.append('ldtoken', data.ldtoken)
    }
    formData.append('name_th', data.nameTh || '')
    formData.append('name_en', data.nameEn || '')
    for (i = 0; i < (data.telephoneList || []).length; i++) {
      formData.append(`telephone[${i}]`, data.telephoneList[i])
    }
    if (data.telephonePpid) {
      formData.append('telephone_ppid', data.telephonePpid)
    }
    formData.append('category_id', data.categoryId)
    formData.append('latitude', data.latitude)
    formData.append('longitude', data.longitude)
    for (i = 0; i < (data.imageList || []).length; i++) {
      formData.append(`images[${i}]`, data.imageList[i])
    }
    for (i = 0; i < (data.imageCommentList || []).length; i++) {
      formData.append(`imagecomments[${i}]`, data.imageCommentList[i])
    }
    formData.append('house_no', data.houseNo || '')
    formData.append('moo', data.moo || '')
    formData.append('parent_pp_id', data.parentPlaceId || '')
    formData.append('floor', data.floor || '')
    formData.append('room', data.room || '')
    formData.append('village_th', data.villageTh || '')
    formData.append('village_en', data.villageEn || '')
    formData.append('condo_th', data.condoTh || '')
    formData.append('condo_en', data.condoEn || '')
    formData.append('building_th', data.buildingTh || '')
    formData.append('building_en', data.buildingEn || '')
    formData.append('alley_th', data.alleyTh || '')
    formData.append('alley_en', data.alleyEn || '')
    formData.append('road_th', data.roadTh || '')
    formData.append('road_en', data.roadEn || '')
    formData.append('subdistrict_th', data.subdistrictTh || '')
    formData.append('subdistrict_en', data.subdistrictEn || '')
    formData.append('district_th', data.districtTh || '')
    formData.append('district_en', data.districtEn || '')
    formData.append('province_th', data.provinceTh || '')
    formData.append('province_en', data.provinceEn || '')
    formData.append('country_th', data.countryTh || '')
    formData.append('country_en', data.countryEn || '')
    formData.append('postcode', data.postcode || '')
    formData.append('address_detail_th', data.addressDetailTh || '')
    formData.append('address_detail_en', data.addressDetailEn || '')
    if (data.geocode) {
      formData.append('geocode', data.geocode)
    }

    self.axios.post(url, formData, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  updatePromptpai (data, ref, callback = false) {
    var self = this
    var url = `${this.site}/ws/promptpai/${data.promptpaiId}`
    var formData = new FormData()
    var i
    // var data = self.getQueryString({
    //   username: username,
    //   ldtoken: ldtoken,
    //   uuid: uuid,
    //   name_en: nameEn,
    //   name_th: nameTh,
    //   address_en: addressEn,
    //   address_th: addressTh,
    //   // telephone: telephone,
    //   category_id: categoryId,
    //   latitude: latitude,
    //   longitude: longitude
    // })
    // // if (telephone === undefined || telephone === null || telephone === '') {
    // //   data += '&telephone='
    // // }
    // if (telephone.length > 0) {
    //   for (var i = 0; i < telephone.length; i++) {
    //     data += `&telephone[${i}]=${telephone[i]}`
    //   }
    // } else {
    //   data += '&telephone='
    // }
    // if (addressEn === undefined || addressEn === null || addressEn === '') {
    //   data += '&address_en='
    // }
    // if (addressTh === undefined || addressTh === null || addressTh === '') {
    //   data += '&address_th='
    // }

    if (data.uuid) {
      formData.append('uuid', data.uuid)
    } else {
      formData.append('username', data.username)
      formData.append('ldtoken', data.ldtoken)
    }
    formData.append('name_th', data.nameTh || '')
    formData.append('name_en', data.nameEn || '')
    for (i = 0; i < (data.telephoneList || []).length; i++) {
      formData.append(`telephone[${i}]`, data.telephoneList[i])
    }
    console.log(data.telephonePpid)
    if (data.telephonePpid) {
      formData.append('telephone_ppid', data.telephonePpid)
    }
    formData.append('category_id', data.categoryId)
    formData.append('latitude', data.latitude)
    formData.append('longitude', data.longitude)
    formData.append('house_no', data.houseNo || '')
    formData.append('moo', data.moo || '')
    formData.append('parent_pp_id', data.parentPlaceId || '')
    formData.append('floor', data.floor || '')
    formData.append('room', data.room || '')
    formData.append('village_th', data.villageTh || '')
    formData.append('village_en', data.villageEn || '')
    formData.append('condo_th', data.condoTh || '')
    formData.append('condo_en', data.condoEn || '')
    formData.append('building_th', data.buildingTh || '')
    formData.append('building_en', data.buildingEn || '')
    formData.append('alley_th', data.alleyTh || '')
    formData.append('alley_en', data.alleyEn || '')
    formData.append('road_th', data.roadTh || '')
    formData.append('road_en', data.roadEn || '')
    formData.append('subdistrict_th', data.subdistrictTh || '')
    formData.append('subdistrict_en', data.subdistrictEn || '')
    formData.append('district_th', data.districtTh || '')
    formData.append('district_en', data.districtEn || '')
    formData.append('province_th', data.provinceTh || '')
    formData.append('province_en', data.provinceEn || '')
    formData.append('country_th', data.countryTh || '')
    formData.append('country_en', data.countryEn || '')
    formData.append('postcode', data.postcode || '')
    formData.append('address_detail_th', data.addressDetailTh || '')
    formData.append('address_detail_en', data.addressDetailEn || '')
    if (data.geocode) {
      formData.append('geocode', data.geocode)
    }

    const asString = new URLSearchParams(formData).toString()

    self.axios.post(url, asString, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  deletePromptpai (promptpaiId, username, ldtoken, uuid, ref, callback = false) {
    var self = this
    var url = `${this.site}/ws/promptpai/${promptpaiId}/delete`
    var data = self.getQueryString({
      username: username,
      ldtoken: ldtoken,
      uuid: uuid
    })
    self.axios.post(url, data, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  addPromptpaiImage (username, ldtoken, uuid, promptpaiId, imageList, imageCommentList, ref, onUploadProgressFunction, executor, callback = false) {
    var self = this
    var url = `${this.site}/ws/promptpai/${promptpaiId}/image`
    var data = new FormData()
    var i
    if (uuid) {
      data.append('uuid', uuid)
    } else {
      data.append('username', username)
      data.append('ldtoken', ldtoken)
    }
    for (i = 0; i < imageList.length; i++) {
      data.append(`images[${i}]`, imageList[i])
    }
    for (i = 0; i < imageCommentList.length; i++) {
      data.append(`imagecomments[${i}]`, imageCommentList[i])
    }

    const CancelToken = self.axios.CancelToken
    self.axios.post(url, data, {
      headers: {
        'Content-type': 'multipart/form-data'
      },
      onUploadProgress: onUploadProgressFunction,
      cancelToken: new CancelToken(executor)
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error)
      }
    })
  }

  deletePromptpaiImage (username, ldtoken, uuid, imageId, ref, callback = false) {
    var self = this
    var url = `${this.site}/ws/promptpai/image/${imageId}/delete`
    var data = self.getQueryString({
      username: username,
      ldtoken: ldtoken,
      uuid: uuid
    })
    self.axios.post(url, data, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  getPhoneNoVerificationStatus (username, ldtoken, uuid, phoneNo, callback = false) {
    var self = this
    var data = self.getQueryString({
      phone_no: phoneNo,
      username: username,
      ldtoken: ldtoken,
      uuid: uuid
    })
    self.axios({
      url: `/verify/checkstatus?${data}`,
      method: 'get',
      baseURL: process.env.LONGDO_MAP_WS_URL,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  sendSmsForPhoneNoVerification (username, ldtoken, uuid, phoneNo, resend, callback = false) {
    var self = this
    var url = `${process.env.LONGDO_MAP_WS_URL}/verify/sendsms`
    var data = self.getQueryString({
      phone_no: phoneNo,
      client: 'promptpai',
      resend: resend,
      username: username,
      ldtoken: ldtoken,
      uuid: uuid
    })
    self.axios.post(url, data, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  verifyPhoneNo (username, ldtoken, uuid, phoneNo, code, callback = false) {
    var self = this
    var url = `${process.env.LONGDO_MAP_WS_URL}/verify/code`
    var data = self.getQueryString({
      phone_no: phoneNo,
      code: code,
      username: username,
      ldtoken: ldtoken,
      uuid: uuid
    })
    self.axios.post(url, data, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  getLineAccessToken (code, callback = false) {
    var self = this
    var url = 'https://api.line.me/oauth2/v2.1/token'
    var data = self.getQueryString({
      grant_type: 'authorization_code',
      code: code,
      redirect_uri: window.location.origin,
      client_id: '1578163560',
      client_secret: '71a76de837d45fc748d0c415e01ce2c7'
    })
    self.axios.post(url, data, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  getPromptpaiStat (callback = false) {
    var self = this
    self.axios({
      url: `/ws/promptpai/stats`,
      method: 'get',
      baseURL: self.site,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  longdoMapSearch (params, callback = false) {
    var self = this
    params.key = process.env.LONGDO_MAP_API_KEY
    var data = self.getQueryString(params)
    self.axios({
      url: `https://search.longdo.com/mapsearch/json/search?${data}`,
      method: 'get',
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  getParentPlaceList (lat, lon, id, callback = false) {
    var self = this
    var data = self.getQueryString({
      lat,
      lon,
      id
    })
    self.axios({
      url: `/place/choices/parent?${data}`,
      method: 'get',
      baseURL: process.env.LONGDO_MAP_WS_URL,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      if (callback) {
        callback(response.data)
      }
    }).catch(function (error) {
      if (callback) {
        console.log(error)
        callback(error.response.data)
      }
    })
  }

  async extractAddress (params) {
    var self = this
    params.key = process.env.LONGDO_MAP_API_KEY
    var data = self.getQueryString(params)
    try {
      const response = await self.axios({
        url: `https://search.longdo.com/smartsearch/json/extract_address/v2?${data}`,
        method: 'get',
        headers: {
          'Content-type': 'application/x-www-form-urlencoded'
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/promptpai.js